export default {
  title: 'خزانه داری',

  banks: {
    title: 'بانک ها',

    insert: {
      title: 'افزودن بانک',

      notifications: {
        insert: {
          success: 'اطلاعات بانک جدید با موفقیت ثبت شد',
          error: 'ثبت اطلاعات بانک جدید با خطا همراه شد'
        }
      }
    },

    list: {
      title: 'بانک ها'
    },

    trash: {
      title: 'سطل زباله بانک ها',

      confirmations: {
        delete: {
          title: 'تاییدیه حذف بانک',
          body: 'آیا از حذف دائم بانک {bank} اطمینان دارید؟'
        }
      },

      notifications: {
        restore: {
          success: 'اطلاعات بانک با موفقیت بازگردانی شد',
          error: 'بازگردانی اطلاعات بانک با خطا همراه شد'
        },

        delete: {
          success: 'حذف دائم اطلاعات بانک با موفقیت انجام شد',
          error: 'حذف دائم اطلاعات بانک با خطا همراه شد'
        }
      }
    },

    edit: {
      title: 'ویرایش بانک',
      dynamicTitle: 'ویرایش بانک {bank}',

      confirmations: {
        delete: {
          title: 'تاییدیه حذف بانک',
          body: 'آیا از حذف موقت بانک {bank} اطمینان دارید؟'
        }
      },

      notifications: {
        edit: {
          success: 'اطلاعات بانک با موفقیت ویرایش شد',
          error: 'ویرایش اطلاعات بانک با خطا همراه شد'
        },

        delete: {
          success: 'حذف اطلاعات بانک با موفقیت انجام شد',
          error: 'حذف اطلاعات بانک با خطا همراه شد'
        }
      }
    },

    bank: {
      title: 'بانک',
      dynamicTitle: 'بانک {bank}',

      importantData: {
        balance: 'موجودی',
        openingBalance: 'اول دوره',
        transactionsCount: 'تعداد تراکنش ها'
      },

      actions: {
        transactions: 'گردش بانک',
        logs: 'لیست لاگ ها'
      }
    },

    transactions: {
      title: 'گردش مالی بانک',
      dynamicTitle: 'گردش مالی بانک {bank}',

      table: {
        header: {
          balance: 'موجودی',
          price: 'مبلغ',
          description: 'مستندات',
          date: 'تاریخ',
          docNumber: 'شماره سند'
        }
      }
    },

    logs: {
      title: 'لاگ های بانک',
    },

    openingBalance: {
      title: '',

      table: {
        header: {
          row: 'ردیف',
          name: 'نام بانک',
          price: 'مبلغ',
          delete: 'حذف'
        }
      },

      notifications: {
        locked: 'اول دوره قفل می باشد',
        negativeBalance: 'بانک نمیتواند موجودی منفی داشته باشد',

        isExisted: {
          message: 'این مقدار در لیست وجود دارد',
          dynamicMessage: 'بانک {bank} در لیست وجود دارد'
        },

        insert: {
          success: 'اول دوره بانک با موفقیت ثبت شد',
          error: 'ثبت اول دوره بانک با خطا همراه شد'
        },

        edit: {
          success: 'اول دوره بانک موردنظر با موفقیت بروزرسانی شد',
          error: 'بروزرسانی اول دوره بانک موردنظر با خطا همراه شد'
        },

        delete: {
          success: 'حذف اول دوره بانک موردنظر با موفقیت انجام شد',
          error: 'حذف اول دوره بانک موردنظر با خطا همراه شد'
        }
      },

      insert: {
        title: 'افزودن اول دوره بانک'
      },

      edit: {
        title: 'ویرایش اول دوره بانک {bank}',

        confirmations: {
          delete: {
            title: 'تائیدیه حذف',
            body: 'آیا از حذف اول دوره بانک مورد نظر اطمینان دارید؟'
          }
        },

        labels: {
          price: 'مبلغ',
          delete: 'حذف اول دوره'
        }
      }
    },

    table: {
      header: {
        select: 'انتخاب',
        row: 'ردیف',
        name: 'نام',
        cardNumber: 'شماره کارت',
        accountNumber: 'شماره حساب',
        balance: 'موجودی',
        delete: 'حذف',
        restore: 'بازگردانی'
      }
    },

    labels: {
      name: 'نام بانک',
      accountNumber: 'شماره حساب',
      cardNumber: 'شماره کارت',
      shebaNumber: 'شماره شبا',
      delete: 'حذف بانک'
    },

    validators: {
      name: 'نام بانک به صورت صحیح وارد نشده است',
      accountNumber: 'شماره حساب به صورت صحیح وارد نشده است',
      cardNumber: 'شماره کارت به صورت صحیح وارد نشده است',
      shebaNumber: 'شماره شبا به صورت صحیح وارد نشده است'
    }
  },

  paymentGateways: {
    title: 'درگاه های پرداخت',

    labels: {
      status: 'وضعیت',
      type: 'نوع',
      bank: 'بانک تسویه',
      title: 'عنوان درگاه',
      endTime: 'ساعت پایان روز کاری درگاه',
      merchantCode: 'کد پذیرنده',
      terminalCode: 'کد پایانه',
      description: 'توضیحات',
      provider: 'ارائه دهنده',
      delete: 'حذف درگاه'
    },

    table: {
      header: {
        restore: 'بازگردانی',
        delete: 'حذف',
        balance: 'موجودی',
        bank: 'بانک تسویه',
        status: 'وضعیت',
        title: 'عنوان درگاه',
        type: 'نوع درگاه',
        row: 'ردیف'
      }
    },

    types: {
      all: 'همه',
      pos: 'کارتخوان',
      online: 'درگاه پرداخت اینترنتی'
    },

    status: {
      all: 'همه',
      enable: 'فعال',
      disable: 'غیرفعال'
    },

    confirmations: {
      delete: {
        title: 'تاییدیه حذف درگاه پرداخت',
        body: 'آیا از حذف دائم «{paymentGateway}» اطمینان دارید؟',
        body1: 'آیا از حذف موقت «{paymentGateway}» اطمینان دارید؟'
      }
    },

    notifications: {
      incorrectData: 'اطلاعات به صورت صحیح وارد نشده است',

      insert: {
        success: 'درگاه پرداخت با موفقیت ایجاد شد',
        error: 'ایجاد درگاه پرداخت با خطا همراه شد'
      },

      edit: {
        success: 'درگاه پرداخت با موفقیت بروزرسانی شد',
        error: 'بروزرسانی درگاه پرداخت با خطا همراه شد'
      },

      delete: {
        success: 'درگاه پرداخت با موفقیت حذف شد',
        error: 'حذف درگاه پرداخت با خطا همراه شد'
      },

      restore: {
        success: 'درگاه پرداخت با موفقیت بازگردانی شد',
        error: 'بازگردانی درگاه پرداخت با خطا همراه شد'
      }
    },

    insert: {
      title: 'افزودن درگاه پرداخت',
      suggestTitle: '{type} بانک {bank}'
    },

    list: {
      title: 'درگاه های پرداخت'
    },

    trash: {
      title: 'سطل زباله درگاه های پرداخت'
    },

    edit: {
      title: 'ویرایش درگاه پرداخت',
      dynamicTitle: 'ویرایش {paymentGateway}'
    },

    paymentGateway: {
      title: 'درگاه پرداخت',
      dynamicTitle: '{paymentGateway}',

      importantData: {
        type: 'نوع',
        bank: 'بانک تسویه',
        balance: 'موجودی'
      },

      actions: {
        transactions: 'گردش مالی',
        receive: 'اعلام وصول',
        logs: 'لیست لاگ ها'
      }
    },

    transactions: {
      title: 'گردش مالی درگاه پرداخت',
      dynamicTitle: 'گردش مالی {paymentGateway}',

      table: {
        header: {
          balance: 'موجودی',
          price: 'مبلغ',
          description: 'مستندات',
          date: 'تاریخ',
          docNumber: 'شماره سند'
        }
      }
    },

    logs: {
      title: 'لاگ های درگاه پرداخت',
    },

    receive: {
      title: 'اعلام وصول درگاه پرداخت',
      dynamicTitle: 'اعلام وصول {paymentGateway}',

      labels: {
        receivedBalance: 'مبلغ وصول شده',
        hasWage: 'کارمزد',
        wage: 'کارمزد کسر شده',
        receiveBalanceWithWage: 'جمع مبلغ وصول شده و کارمزد',
        receivedBalanceTransferId: 'شماره پیگیری',
        totalBalance: 'موجودی کل',
        receivedYesterdayBalance: 'موجودی قابل وصول'
      },

      notifications: {
        balanceIsNotEnough: 'مبلغ وارد شده از موجودی درگاه بیشتر است',
        incorrectPriceOrId: 'مبلغ و یا شماره پیگیری به طور صحیح وارد نشده است',
        incorrect_reference_id: 'شماره تراکنش وارد شده تکراری می باشد',

        receive: {
          success: 'اعلام وصول با موفقیت ثبت شد',
          error: 'اعلام وصول با خطا همراه شد'
        }
      }
    }
  },

  cashBoxes: {
    title: 'صندوق ها',

    labels: {
      name: 'نام صندوق',
      delete: 'حذف صندوق'
    },

    confirmations: {
      delete: {
        title: 'تاییدیه حذف صندوق',
        body: 'آیا از حذف موقت صندوق {cashBox} اطمینان دارید؟'
      },
      forceDelete: {
        title: 'تاییدیه حذف صندوق',
        body: 'آیا از حذف دائم صندوق {cashBox} اطمینان دارید؟'
      }
    },

    notifications: {
      insert: {
        success: 'اطلاعات صندوق جدید با موفقیت ایجاد شد',
        error: 'ثبت اطلاعات صندوق جدید با خطا همراه شد'
      },

      edit: {
        success: 'اطلاعات صندوق با موفقیت بروزرسانی شد',
        error: 'بروزرسانی اطلاعات صندوق جدید با خطا همراه شد'
      },

      delete: {
        success: 'اطلاعات صندوق با موفقیت حذف شد',
        error: 'حذف اطلاعات صندوق جدید با خطا همراه شد'
      },

      restore: {
        success: 'اطلاعات صندوق با موفقیت بازگردانی شد',
        error: 'بازگردانی اطلاعات صندوق جدید با خطا همراه شد'
      }
    },

    table: {
      header: {
        select: 'انتخاب',
        row: 'ردیف',
        name: 'نام',
        balance: 'موجودی',
        delete: 'حذف',
        restore: 'بازگردانی'
      }
    },

    list: {
      title: 'صندوق ها'
    },

    trash: {
      title: 'سطل زباله صندوق ها'
    },

    insert: {
      title: 'افزودن صندوق'
    },

    edit: {
      title: 'ویرایش صندوق',
      dynamicTitle: 'ویرایش صندوق {cashBox}'
    },

    cashBox: {
      title: 'صندوق',
      dynamicTitle: 'صندوق {cashBox}',

      importantData: {
        balance: 'موجودی',
        openingBalance: 'اول دوره',
        transactionsCount: 'تعداد تراکنش ها'
      },

      actions: {
        transactions: 'گردش صندوق',
        logs: 'لیست لاگ ها'
      }
    },

    transactions: {
      title: 'گردش مالی صندوق',
      dynamicTitle: 'گردش مالی صندوق {cashBox}',

      table: {
        header: {
          balance: 'موجودی',
          price: 'مبلغ',
          description: 'مستندات',
          date: 'تاریخ',
          docNumber: 'شماره سند'
        }
      }
    },

    logs: {
      title: 'لاگ های صندوق',
    },

    openingBalance: {

      labels: {
        price: 'مبلغ',
        delete: 'حذف اول دوره'
      },

      confirmations: {
        delete: {
          title: 'تاییدیه حذف',
          body: 'آیا از حذف اول دوره صندوق مورد نظر اطمینان دارید؟'
        }
      },

      notifications: {
        locked: 'اول دوره قفل می باشد',
        negativeBalance: 'صندوق نمیتواند موجودی منفی داشته باشد',

        isExisted: {
          message: 'این مقدار در لیست وجود دارد',
          dynamicMessage: 'صندوق {cashBox} در لیست وجود دارد'
        },

        insert: {
          success: 'اول دوره صندوق مورد نظر با موفقیت ثبت شد',
          error: 'ثبت اول دوره صندوق مورد نظر با خطا همراه شد'
        },

        edit: {
          success: 'اول دوره صندوق مورد نظر با موفقیت بروزرسانی شد',
          error: 'بروزرسانی اول دوره صندوق مورد نظر با خطا همراه شد'
        },

        delete: {
          success: 'اول دوره صندوق مورد نظر با موفقیت حذف شد',
          error: 'حذف اول دوره صندوق مورد نظر با خطا همراه شد'
        }
      },

      table: {
        header: {
          delete: 'حذف',
          price: 'مبلغ',
          name: 'نام صندوق',
          row: 'ردیف'
        }
      },

      insert: {
        title: 'افزودن اول دوره صندوق'
      },

      edit: {
        title: 'ویرایش اول دوره صندوق {cashBox}'
      }
    }
  },

  cost: {
    title: 'هزینه ها',

    paymentTypes: {
      cash: 'دریافت وجه نقد',
      bank: 'دریافت کارت‌به‌کارت یا شبا',
      paymentGateway: 'دریافت پوز یا درگاه'
    },

    bankTypes: {
      pos: 'POS',
      card: 'کارت به کارت',
      sheba: 'شبا'
    },

    types: {
      cash: 'صندوق',
      bank: 'بانک',
      user: 'هزینه به اپراتور',
      storeroom: 'انبار',
      paymentGateway: 'درگاه پرداخت',
      custom: 'هزینه به سرفصل'
    },

    labels: {
      all: 'همه',
      type: 'نوع',
      account: 'سرفصل هزینه',
      cash: 'پرداخت از صندوق',
      bank: 'پرداخت از بانک',
      payer: 'پرداخت کننده',
      paymentType: 'نوع پرداخت',
      price: 'مبلغ',
      description: 'توضیحات',
      date: 'تاریخ واریز',
      paymentFrom: 'پرداخت از',
      paymentTo: 'پرداخت به',
      maxPayment: 'حداکثر قابل پرداخت',
      bankBalance: 'موجودی بانک',
      cashBoxBalance: 'موجودی صندوق',
      userBalance: 'موجودی اپراتور'
    },

    placeholder: {
      date: 'اتوماتیک'
    },

    table: {
      header: {
        restore: 'بازگردانی',
        delete: 'حذف',
        price: 'مبلغ',
        account: 'سرفصل هزینه',
        payer: 'طرف حساب',
        creator: 'ایجاد کننده',
        date: 'تاریخ',
        docNumber: 'شماره سند'
      }
    },

    notifications: {
      print: {
        success: 'درخواست شما ارسال شد، لطفا منتظر بمانید',
        error: 'درخواست پرینت با خطا شد'
      }
    },

    validators: {
      dateHelp: 'ورودی باید به صورت {date} وارد شود.',
      date: 'تاریخ واریز درست وارد نشده است!',
      type: 'نوع پرداخت مشخص نشده است',
      price: 'مبلغ وارد شده بیشتراز حداکثر میزان قابل پرداخت است!',
      future: 'نمیتوان برای آینده هزینه ثبت کرد',
      user: 'پرداخت کننده انتخاب نشده است'
    },

    insert: {
      title: 'هزینه جدید',

      notifications: {
        invalidAccount: 'سرفصل هزینه انتخاب نشده است',
        invalidCash: 'صندوق انتخاب نشده است',
        invalidBank: 'بانک انتخاب نشده است',
        invalidPrice: 'مبلغ وارد شده معتبر نیست',
        invalidPaymentType: 'نوع پرداخت مشخص نشده است',
        invalidDescription: 'توضیحات هزینه وارد نشده است',
        lowBalance: 'موجودی بانک یا صندوق کافی نمیباشد!',
        lowBalanceDynamicDate: 'موجودی بانک یا صندوق در تاریخ انتخاب شده کافی نمیباشد!',
        incorrect_reference_id: 'شماره تراکنش وارد شده تکراری می باشد',

        insert: {
          success: 'سند هزینه با موفقیت ایجاد شد',
          error: 'ایجاد سند هزینه با خطا همراه شد'
        }
      },

      suggests: {
        description: 'دریافت از {user} بابت {subject}'
      }
    },

    list: {
      title: 'هزینه ها'
    },

    trash: {
      title: 'سطل زباله هزینه ها'
    },

    document: {
      title: 'سند هزینه',
      dynamicTitle: 'سند هزینه شماره {docNumber}',

      confirmations: {
        delete: {
          title: 'تائیدیه حذف سند',
          body: 'آیا از حذف کامل اطلاعات این سند اطمینان دارید؟'
        }
      },

      notifications: {
        delete: {
          success: 'اطلاعات سند هزینه با موفقیت حذف شد',
          error: 'حذف اطلاعات سند هزینه با خطا همراه شد'
        },
        restore: {
          success: 'اطلاعات سند هزینه با موفقیت بازگردانی شد',
          error: 'بازگردانی اطلاعات سند هزینه با خطا همراه شد'
        },
      },

      labels: {
        payer: 'پرداخت کننده',
        account: 'سرفصل هزینه',
        details: 'سایر اطلاعات',
        creator: 'ایجادکننده',
        date: 'تاریخ ثبت',
        description: 'توضیحات',
        attachments: 'پیوست ها'
      }
    },

    logs: {
      title: 'لاگ های هزینه',
    },
  },

  payment: {
    title: 'پرداخت ها',

    bankTypes: {
      pos: 'POS',
      card: 'کارت به کارت',
      sheba: 'شبا'
    },

    types: {
      cash: 'صندوق',
      bank: 'بانک',
      user: 'اپراتور',
      app: 'اپلیکیشن',
      storeroom: 'انبار',
      paymentGateway: 'درگاه پرداخت'
    },

    paymentTypes: {
      customer: 'پرداخت به مشتری',
      supplier: 'پرداخت به تامین کننده'
    },

    labels: {
      all: 'همه',
      type: 'نوع',
      paymentType: 'نوع پرداخت',
      payeeType: 'نوع پرداخت کننده',
      date: 'تاریخ پرداخت',
      user: 'پرداخت به',
      source: 'پرداخت از',
      price: 'مبلغ',
      description: 'توضیحات',
      transactionsReferenceId: 'شماره پیگیری',
      maxPayment: 'حداکثر قابل پرداخت',
      dynamicBalance: 'اعتبار {balance}',
      bankBalance: 'موجودی بانک',
      cashBoxBalance: 'موجودی صندوق'
    },

    placeholder: {
      date: 'اتوماتیک'
    },

    table: {
      header: {
        restore: 'بازگردانی',
        delete: 'حذف',
        price: 'مبلغ',
        destination: 'دریافت کننده',
        source: 'پرداخت کننده',
        description: 'مستندات',
        creator: 'ایجادکننده',
        date: 'تاریخ',
        docNumber: 'شماره سند'
      }
    },

    notifications: {
      print: {
        success: 'درخواست شما ارسال شد، لطفا منتظر بمانید',
        error: 'درخواست پرینت با خطا شد'
      }
    },

    validators: {
      dateHelp: 'ورودی باید به صورت {date} وارد شود.',
      date: 'تاریخ پرداخت درست وارد نشده است!',
      future: 'نمیتوان برای آینده پرداخت ثبت کرد'
    },

    insert: {
      title: 'پرداخت جدید',

      notifications: {
        invalidUser: 'اپراتور انتخاب نشده است',
        invalidPrice: 'مبلغ وارد شده معتبر نیست',
        invalidPaymentFrom: 'مبدا پرداخت انتخاب نشده است',
        invalidPaymentType: 'نوع پرداخت مشخص نشده است',
        invalidDescription: 'توضیحات پرداخت وارد نشده است',
        price: 'مبلغ وارد شده بیشتراز حداکثر میزان قابل پرداخت است!',
        lowBalance: 'موجودی بانک یا صندوق کافی نمیباشد!',
        lowBalanceDynamicDate: 'موجودی بانک یا صندوق در تاریخ انتخاب شده کافی نمیباشد!',
        incorrect_reference_id: 'شماره تراکنش وارد شده تکراری می باشد',

        insert: {
          success: 'سند پرداخت با موفقیت ایجاد شد',
          error: 'ایجاد سند پرداخت با خطا همراه شد'
        }
      },

      suggests: {
        description: 'دریافت از {user} بابت {subject}'
      }
    },

    list: {
      title: 'پرداخت ها'
    },

    trash: {
      title: 'سطل زباله پرداخت ها'
    },

    document: {
      title: 'سند پرداخت',
      dynamicTitle: 'سند پرداخت شماره {docNumber}',

      confirmations: {
        delete: {
          title: 'تائیدیه حذف سند',
          body: 'آیا از حذف کامل اطلاعات این سند اطمینان دارید؟'
        }
      },

      notifications: {
        delete: {
          success: 'اطلاعات سند پرداخت با موفقیت حذف شد',
          error: 'حذف اطلاعات سند پرداخت با خطا همراه شد'
        },
        restore: {
          success: 'اطلاعات سند پرداخت با موفقیت بازگردانی شد',
          error: 'بازگردانی اطلاعات سند پرداخت با خطا همراه شد'
        },
      },

      labels: {
        sources: 'پرداخت کننده/پرداخت کنندگان',
        destinations: 'دریافت کننده/دریافت کنندگان',
        details: 'سایر اطلاعات',
        creator: 'ایجادکننده',
        date: 'تاریخ ثبت',
        description: 'توضیحات',
        attachments: 'پیوست ها'
      }
    },

    logs: {
      title: 'لاگ های پرداخت',
    },
  },

  receive: {
    title: 'دریافت ها',

    statusTypes: {
      all: 'همه',
      confirm: 'تایید شده',
      cancel: 'لغو شده'
    },

    receiveTypes: {
      cash: 'وجه نقد',
      bank: 'انتقال بانکی',
      paymentGateway: 'پوز یا درگاه'
    },

    types: {
      cash: 'صندوق',
      bank: 'بانک',
      user: 'اپراتور',
      app: 'اپلیکیشن',
      storeroom: 'انبار',
      paymentGateway: 'درگاه پرداخت'
    },

    status: {
      confirm: 'تایید شده',
      reject: 'مرجوع شده',
      draft: 'تایید نشده'
    },

    labels: {
      all: 'همه',
      receiveType: 'نوع دریافت وجه',
      receiverType: 'نوع دریافت کننده',
      subscriptionCredit: 'اعتبار اشتراک فعلی',
      wallet: 'کیف پول',
      credit: 'بدهکاری',
      user: 'دریافت از',
      cash: 'واریز به صندوق',
      bank: 'واریز به بانک',
      paymentGateway: 'واریز به درگاه',
      price: 'مبلغ',
      date: 'تاریخ واریز',
      description: 'توضیحات',
      transactionsReferenceId: 'شماره پیگیری',
      balance: 'موجودی کیف پول',
      remainingPrice: 'قیمت باقی مانده'
    },

    placeholder: {
      date: 'اتوماتیک'
    },

    table: {
      header: {
        restore: 'بازگردانی',
        delete: 'حذف',
        status: 'وضعیت',
        price: 'مبلغ',
        destination: 'دریافت کننده',
        source: 'پرداخت کننده',
        description: 'مستندات',
        creator: 'ایجادکننده',
        date: 'تاریخ',
        referenceId: 'شماره تراکنش',
        docNumber: 'شماره سند'
      }
    },

    notifications: {
      cantReturn: 'این سند دریافت قابل مرجوع شدن نیست',

      print: {
        success: 'درخواست شما ارسال شد، لطفا منتظر بمانید',
        error: 'درخواست پرینت با خطا شد'
      },

      return: {
        success: 'سند دریافت با موفقیت مرجوع شد',
        error: 'مرجوع شدن سند دریافت با خطا همراه شد'
      }
    },

    validators: {
      dateHelp: 'ورودی باید به صورت {date} وارد شود.',
      date: 'تاریخ دریافت درست وارد نشده است!',
      future: 'نمیتوان برای آینده دریافت ثبت کرد'
    },

    insert: {
      title: 'دریافت جدید',
      dynamicTitle: 'دریافت وجه از {name}',

      notifications: {
        invalidType: 'نوع دریافت وجه انتخاب نشده است',
        invalidUser: 'اپراتور انتخاب نشده است',
        invalidPrice: 'مبلغ وارد نشده است',
        lessPrice: 'مبلغ وارد شده نباید کم تر از {price} {currency} باشد',
        morePrice: 'مبلغ وارد شده نباید بیشتر از {price} {currency} باشد',
        invalidDescription: 'توضیحات دریافت وارد نشده است',
        invalidTransactionsReferenceId: 'شماره پیگیری اشتباه وارد شده است',
        invalidCash: 'صندوق انتخاب نشده است',
        invalidBank: 'بانک انتخاب نشده است',
        invalidPaymentGateway: 'درگاه انتخاب نشده است',
        incorrect_reference_id: 'شماره تراکنش وارد شده تکراری می باشد',

        insert: {
          success: 'سند دریافت با موفقیت ایجاد شد',
          error: 'ایجاد سند دریافت با خطا همراه شد'
        },

        parseError: {
          name: 'نام انتخاب شده معتبر نیست!',
          price: 'مبلغ انتخاب شده معتبر نیست!',
          referenceId: 'شماره پیگیری وارد شده قبلا استفاده شده است!',
          paymentGateway: 'درگاه پرداخت انتخابی معتبر نیست!'
        }
      },

      suggests: {
        description: 'دریافت از {user} بابت {subject}'
      },

      table: {
        header: {
          row: 'ردیف',
          name: 'عنوان',
          price: 'مبلغ'
        }
      }
    },

    list: {
      title: 'دریافت ها'
    },

    trash: {
      title: 'سطل زباله دریافت ها'
    },

    document: {
      title: 'سند دریافت',
      dynamicTitle: 'سند دریافت شماره {docNumber}',

      confirmations: {
        delete: {
          title: 'تائیدیه حذف سند',
          body: 'آیا از حذف کامل اطلاعات این سند اطمینان دارید؟'
        },
        return: {
          title: 'تائیدیه مرجوع دریافت',
          body: 'آیا از مرجوع کردن این سند دریافت اطمینان دارید؟'
        }
      },

      notifications: {
        delete: {
          success: 'اطلاعات سند دریافت با موفقیت حذف شد',
          error: 'حذف اطلاعات سند دریافت با خطا همراه شد'
        },
        restore: {
          success: 'اطلاعات سند دریافت با موفقیت بازگردانی شد',
          error: 'بازگردانی اطلاعات سند دریافت با خطا همراه شد'
        },
        return: {
          success: 'سند دریافت با موفقیت مرجوع شد',
          error: 'مرجوع شدن سند دریافت با خطا همراه شد'
        }
      },

      labels: {
        sources: 'پرداخت کننده/پرداخت کنندگان',
        destinations: 'دریافت کننده/دریافت کنندگان',
        details: 'سایر اطلاعات',
        referenceId: 'شماره تراکنش',
        creator: 'ایجادکننده',
        status: 'وضعیت',
        date: 'تاریخ ثبت',
        description: 'توضیحات',
        attachments: 'پیوست ها'
      }
    },

    return: {
      title: 'افزودن مرجوع دریافت',

      labels: {
        user: 'پرداخت به',
        date: 'تاریخ پرداخت',
        source: 'پرداخت از',
        receivePrice: 'مبلغ دریافت',
        price: 'مبلغ',
        description: 'توضیحات',
        descriptionText: 'مرجوع دریافت برای سند دریافت شماره {id}'
      }
    },

    logs: {
      title: 'لاگ های دریافت',
    },
  },

  internalFundsTransfer: {
    title: 'انتقالی خزانه',

    types: {
      cash: 'صندوق',
      bank: 'بانک',
      user: '',
      storeroom: 'انبار',
      paymentGateway: 'درگاه پرداخت'
    },

    labels: {
      sourceType: 'برداشت از',
      source: '{type} مبدا',
      destinationType: 'واریز به',
      destination: '{type} مقصد',
      price: 'مبلغ',
      date: 'تاریخ انتقال',
      bankBalance: 'موجودی بانک',
      cashBoxBalance: 'موجودی صندوق',
      hasWage: 'کارمزد',
      wage: 'کارمزد کسر شده',
      referenceId: 'شماره پیگیری',
      description: 'توضیحات'
    },

    placeholder: {
      date: 'اتوماتیک'
    },

    table: {
      header: {
        restore: 'بازگردانی',
        delete: 'حذف',
        price: 'مبلغ',
        description: 'مستندات',
        payee: 'دریافت کننده',
        payer: 'پرداخت کننده',
        creator: 'ایجادکننده',
        date: 'تاریخ',
        referenceId: 'شماره تراکنش',
        docNumber: 'شماره سند'
      }
    },

    notifications: {
      print: {
        success: 'درخواست شما ارسال شد، لطفا منتظر بمانید',
        error: 'درخواست پرینت با خطا شد'
      }
    },

    validators: {
      dateHelp: 'ورودی باید به صورت {date} وارد شود.',
      date: 'تاریخ انتقال درست وارد نشده است!',
      future: 'نمیتوان برای آینده انتقالی ثبت کرد'
    },

    insert: {
      title: 'انتقالی خزانه جدید',

      notifications: {
        invalidPrice: 'مبلغ وارد شده معتبر نیست',
        invalidSourceType: 'نوع مبدا انتخاب نشده است',
        invalidSource: 'مبدا انتخاب نشده است',
        invalidDestinationType: 'نوع مقصد انتخاب نشده است',
        invalidDestination: 'مقصد انتخاب نشده است',
        equalSourceAndDestination: 'مبدا و مقصد نمی تواند یکسان باشد',
        lowBalance: 'موجودی یانک یا صندوق کافی نمی باشد',
        invalidDescription: 'توضیحات وارد نشده است',
        lowBalanceDynamicDate: 'موجودی بانک یا صندوق در تاریخ انتخاب شده کافی نمیباشد!',
        incorrect_reference_id: 'شماره تراکنش وارد شده تکراری می باشد',

        insert: {
          success: 'سند انتقال وجه داخلی با موفقیت ایجاد شد',
          error: 'ایجاد سند انتقال وجه داخلی با خطا همراه شد'
        }
      }
    },

    list: {
      title: 'لیست انتقالی خزانه'
    },

    trash: {
      title: 'سطل زباله انتقالی خزانه ها'
    },

    document: {
      title: 'سند انتقالی خزانه',
      dynamicTitle: 'سند انتقالی خزانه شماره {docNumber}',

      confirmations: {
        delete: {
          title: 'تائیدیه حذف سند',
          body: 'آیا از حذف کامل اطلاعات این سند اطمینان دارید؟'
        }
      },

      notifications: {
        delete: {
          success: 'اطلاعات سند انتقالی خزانه با موفقیت حذف شد',
          error: 'حذف اطلاعات سند انتقالی خزانه با خطا همراه شد'
        },
        restore: {
          success: 'اطلاعات سند انتقالی خزانه با موفقیت بازگردانی شد',
          error: 'بازگردانی اطلاعات سند انتقالی خزانه با خطا همراه شد'
        }
      },

      labels: {
        payer: 'پرداخت کننده/پرداخت کنندگان',
        destinations: 'دریافت کننده/دریافت کنندگان',
        details: 'سایر اطلاعات',
        referenceId: 'شماره تراکنش',
        creator: 'ایجادکننده',
        date: 'تاریخ ثبت',
        description: 'توضیحات',
        attachments: 'پیوست ها'
      }
    },

    logs: {
      title: 'لاگ های انتقالی خزانه',
    },
  },

  transactions: {
    title: 'تراکنش های مالی',

    list: {
      title: 'تراکنش های مالی'
    },

    insert: {
      title: 'افزودن تراکنش'
    },

    transaction: {
      title: 'تراکنش'
    }
  }
}
